<template>
  <div class="container">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item
        v-for="(item, index) in banners"
        :key="index"
        :title="item.name"
        :value="item.name"
      >
        <img
          :src="item.imgUrl"
          alt=""
          class="banner_img"
          @click="tolink(item)"
        />
      </van-swipe-item>
    </van-swipe>
    <div class="middleContainer">
      <van-grid :border="false">
        <van-grid-item text="培训课程" to="/courseList?currentIndex=0">
          <van-image
            :src="require('../../assets/img/class.png')"
            class="img_logo"
          />
          <div class="txt_logo">全部课程</div>
        </van-grid-item>
        <van-grid-item text="" to="/courseList?currentIndex=1">
          <van-image :src="require('../../assets/img/exam.png')" />
          <div class="txt_logo">视频课</div>
        </van-grid-item>
        <van-grid-item text="" to="/courseList?currentIndex=2">
          <van-image :src="require('../../assets/img/meet.png')" />
          <div class="txt_logo">音频课</div>
        </van-grid-item>
        <van-grid-item text="" to="/courseList?currentIndex=3">
          <van-image :src="require('../../assets/img/sc.png')" />
          <div class="txt_logo">产品解析</div>
        </van-grid-item>
      </van-grid>
    </div>

    <div class="contentContainer">
      <div class="titleBar" @click="toCourseList">
        精选课程
        <van-icon name="arrow" style="float: right" />
      </div>
      <coursecell
        :coursedata="courseList"
        @footerRefresh="getcourse"
        :loading="listLoading"
        :finished="listFinished"
        @watchCourse="watchCourse"
      ></coursecell>
    </div>
    <Footer page="index"></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import Footer from "@/components/Footer";
import { Toast } from "vant";
import { Grid, GridItem } from "vant";
import coursecell from "@/views/viewcomponents/courseCell";
import { getBanners, getCourse } from "../../api/apis"
import { getToken } from "../../utils/auth";

Vue.use(Grid);
Vue.use(GridItem);
const size = 5;
let page = -1;

export default {
  components: {
    Footer,
    coursecell,
  },

  data() {
    return {
      code: null,
      list: [],
      banners: [],
      courseList: [],
      listFinished: false,
      listLoading: false,
      jobIds: "",
      deptId: "",
      page:0
    };
  },

  created() {
      // 友盟统计添加
    const script = document.createElement("script");
    script.src = "https://s9.cnzz.com/z_stat.php?id=1279725175&web_id=1279725175"; //该路径为点击统计代码后，页面中第一个 文字统计 script代码
    script.language = "JavaScript";
    document.body.appendChild(script);
    // --------------------------------
    this.getBanner();
    let index = this.active + 1;
    // this.list = this[`list${index}`]; // this.list1
    //判断是否存有token，有token就什么也不用做，没有就请求wxsocial接口\
    console.log("getTocken++++++++++", getToken());
    let jobIds = [];
    // 获取职责id
    let arr = "";
    if (this.$store.state.user.user.user) {
      console.log(this.$store.state.user.user.user);
      arr = this.$store.state.user.user.user.jobs;
      this.deptId = this.$store.state.user.user.user.dept.id;
    }
    console.log(this.$store.state.user.user);
    if (arr.length > 0) {
      arr.forEach((item) => jobIds.push(item.id));
      this.jobIds = jobIds.join(",");
    }
  },
  methods: {
    watchCourse(index) {
      console.log(index);
      this.$router.push({
        path: "/courseDetail",
        query: {
          courseId: this.courseList[index].id,
        },
      });
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    onchange(index) {
      this.list = this[`list${index + 1}`];
    },

    getBanner() {
      let that = this;
      getBanners({ enabled: true })
        .then((res) => {
          console.log("+++++++");
          that.banners = res.content;
        })
        .catch((res) => {
          Toast("请求失败处理");
        });
    },
    getcourse() {
      //置顶的课程
      let that = this;
      const params = {
        isTop: true,
        enabled: true,
        page: this.page,
        size: size,
        jobIds: this.jobIds,
        deptId: this.deptId
      };
      if (that.listLoading) {
        return;
      }
      if (that.listFinished) {
        return;
      }
      that.listLoading = true;
      getCourse(params)
        .then((res) => {
          let totalElements = res.totalElements;
          if(res.content.length>0){
            this.page++
            that.courseList = that.courseList.concat(res.content);
            that.listFinished = false;
            that.listLoading = false;
          }else{
            that.listFinished = true;
            that.listLoading = false;
          }
          
        })
        .catch((res) => {
          that.listLoading = false;
          that.listFinished = true;
        });
    },
    toCourseList() {
      this.$router.push({
        path: "/courseList?currentIndex=0",
      });
    },
    tolink(item) {
      if (item.type == "link") {
        // window.location.href = item.link;
        window.open(item.link, "_blank");
      } else {
        this.$router.push({
          path: "/courseDetail",
          query: { courseId: item.link },
        });
      }
    },
  },
};
</script>

<style lang="less">
.my-swipe {
  border-radius: 6px;
  height: 164px;
  width: 100%;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  background-color: #39a9ed;
  border-radius: 6px;
}
.container {
  margin-bottom: 90px;
  padding: 10px 13px;
}
.middleContainer {
  margin: 13px 0;
  background-color: #ffffff;
  border-radius: 6px;
  overflow: hidden;
}

.contentContainer {
  padding: 13px 13px 0px 13px;
  background-color: #ffffff;
  border-radius: 6px;
  overflow: hidden;
  .titleBar {
    padding: 0 0 0 10px;
    border-left: 5px solid #ff960b;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 13px;
  }
}
.banner_img {
  width: 101%;
  height: 100%;
  border-radius: 6px;
}
.img_logo {
  width: 40px;
  height: 40px;
}
.txt_logo {
  color: rgba(151, 144, 144, 100);
  font-size: 14px;
  text-align: center;
  font-family: PingFangSC-regular;
  margin-top: 6px;
}
</style>
